import { render, staticRenderFns } from "./SearchAllBusinessList.vue?vue&type=template&id=6bb826c0&"
import script from "./SearchAllBusinessList.vue?vue&type=script&lang=js&"
export * from "./SearchAllBusinessList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports